import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { flow, observable, runInAction } from "mobx";
import { locationRestTemplatesServiceUseGet } from "../wp-api";
import { request } from "../utils";
class ServiceTemplate {
    constructor(template, store){
        this.busy = false;
        this.fetchUse = flow(function*() {
            try {
                this.busy = true;
                const response = yield request({
                    location: locationRestTemplatesServiceUseGet,
                    params: {
                        identifier: this.data.identifier
                    }
                });
                this.use = response;
                return this.use;
            } catch (e) {
                console.log(e);
                throw e;
            } finally{
                this.busy = false;
            }
        });
        runInAction(()=>{
            this.data = template;
        });
        this.store = store;
    }
}
_ts_decorate([
    observable
], ServiceTemplate.prototype, "busy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], ServiceTemplate.prototype, "data", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof ResponseRouteTemplatesServiceUseGet === "undefined" ? Object : ResponseRouteTemplatesServiceUseGet)
], ServiceTemplate.prototype, "use", void 0);
export { ServiceTemplate };
